<app-mystery-school-header></app-mystery-school-header>
<div class="mainwrapper">
  <!-- <div class="new-container admin_dashboard_list"> -->
  <!-- <app-login-info></app-login-info> -->
  <!-- <ng-container *ngIf="loader">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container> -->
  <!-- <div class="data_section_main">
      <div class="data_sec_wrpr">
        <div class="all_data_sub_wrpr_sec">
          <img
            src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/mail_icon_img.webp"
          />
          <h5><strong>Email:</strong> {{ cookieData?.userinfo?.email }}</h5>
        </div>

        <div class="all_data_sub_wrpr_sec">
          <img
            src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/amount_icon_img.webp"
          />
          <h5><strong>Amount:</strong> $10/month</h5>
        </div>
        <div class="all_data_sub_wrpr_sec">
          <img
            src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/created_date_icon_img.webp"
          />
          <h5>
            <strong>Subscription Renewal Date:</strong>
            {{
              cookieData?.userinfo?.mystery_current_period_end
                | date : "EEEE, MMMM d, y"
            }}
          </h5>
        </div>

        <div
          *ngIf="cookieData?.userinfo?.mystery_subscription_status"
          class="all_data_sub_wrpr_sec"
        >
          <button
            mat-raised-button
            class="subscribed_btn"
            (click)="unsubscribeOpen()"
          >
            Subscribed
          </button>
        </div>
        <div
          *ngIf="!cookieData?.userinfo?.mystery_subscription_status"
          class="all_data_sub_wrpr_sec"
        >
          <button
            mat-raised-button
            class="subscribe_btn"
            (click)="subscribeOpen()"
          >
            Subscribe
          </button>
        </div>
      </div>
    </div> -->
  <!-- <div class="subwrapper">

      <h1 style="margin: 0; color: #ffffff; text-align: center">
        Welcome to Mystery School Dashboard
      </h1>
    </div>


    <div class="subwrapper">
      <p style="margin: 0; color: #ffffff; text-align: center"><strong>Current Date:</strong> {{ today | date: 'MMMM d, y' }}</p>
      <p style="margin: 0; color: #ffffff; text-align: center"><strong>Current Astrological Position:</strong> {{ astro?.sign }} – {{ astro?.decan }}</p>
      <p style="margin: 0; color: #ffffff; text-align: center"><strong>Date Range:</strong> {{ astro?.range }}</p>
      <p style="margin: 0; color: #ffffff; text-align: center"><strong>Thematic Context:</strong> {{ astro?.theme }}</p>
    </div>


    <div style="color: #ffffff;" class="subwrapper">
      <h2>🧭 Curriculum Map</h2>
      <p><em>Maps the Astrological Wheel:</em></p>
    
      <div *ngFor="let quarter of quarters" class="quarter-block">
        <h3>{{ quarter.title }} <span class="season">({{ quarter.season }})</span></h3>
        <p>
          <ng-container *ngFor="let sign of quarter.signs; let i = index">
            <span [ngClass]="getSignStatus(sign)">
              {{ sign.name }}
            </span>
            <span *ngIf="i < quarter.signs.length - 1"> | </span>
          </ng-container>
        </p>
      </div>
    
      <div class="intro-link mt-4">
        <a href="/intro-materials" target="_blank">📚 Access Introductory Materials (PDFs & Videos)</a>
      </div>
    </div> -->

  <!-- << -------------- Old Dashboard ---------------- >> -->

  <!-- <div class="subwrapper">
      <div class="welcome_block">
        <div class="welcome_block_title_container">
          <h1 class="welcome_block_title">Mystery School Dashboard</h1>
          <p class="welcome_block_subtitle">
            Your journey through the cosmic mysteries
          </p>
        </div>
        <div class="current_phase_container">
          <div class="phase_text_wrapper">
            <p class="phase_text_primary">Current Phase</p>
            <p class="phase_text_secondary">Gemini Decan 2</p>
          </div>
          <div class="phase_indicator_wrapper">
            <div class="phase_indicator"></div>
          </div>
        </div>
      </div>
    </div>


    <div class="subwrapper mystery_dashboard_datamain">
      <div class="mystery_dashboard_datawrap">
        <div class="mystery_dashboard_data_leftsec">
          <div class="mystery_dashboard_dataleft_block1">
            <div class="wrapper">
              <div class="block1_headingwrap">
                <div class="block1_heading_innerwrap">
                  <h3>
                    <div class="block1_starwrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-star h-6 w-6"
                      >
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                        ></path>
                      </svg>
                    </div>
                    <div class="block1_heading_lefttext">
                      <h2>Welcome Back, Seeker</h2>
                      <p>Continue your mystical journey</p>
                    </div>
                  </h3>
                  <div class="dataleft_common_chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-calendar h-3 w-3 mr-1"
                    >
                      <path d="M8 2v4"></path>
                      <path d="M16 2v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </svg>
                    June 6, 2025
                  </div>
                </div>
              </div>
              <div class="wrapper wrapper_inner">
                <div class="block1_contentwrap">
                  <div class="dataleft_block_headingwrap">
                    <div class="dataleft_block_headingicon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-zap h-5 w-5 text-primary"
                      >
                        <path
                          d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                        ></path>
                      </svg>
                    </div>
                    <div class="dataleft_block_section">
                      <h3>Current Focus</h3>
                      <p>Active Learning Phase</p>
                    </div>
                  </div>
                  <div class="block1_content">
                    <div class="block1_content_headingdate_wrap">
                      <h4>Gemini - Decan 2</h4>
                      <div
                        class="dataleft_common_chip block1_content_dateyear_wrapper"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-calendar h-3 w-3 mr-1"
                        >
                          <path d="M8 2v4"></path>
                          <path d="M16 2v4"></path>
                          <rect
                            width="18"
                            height="18"
                            x="3"
                            y="4"
                            rx="2"
                          ></rect>
                          <path d="M3 10h18"></path>
                        </svg>
                        June 1-10
                      </div>
                    </div>
                    <div class="block1_content_progresssec">
                      <div class="block1_content_progress_content">
                        <span class="progress_text">Progress</span
                        ><span class="progress_value">60%</span>
                      </div>
                      <div class="block1_content_progress_bar">
                        <mat-progress-bar
                          mode="determinate"
                          value="60"
                        ></mat-progress-bar>
                      </div>
                    </div>
                    <div class="block1_content_description">
                      <p>
                        <span>Venus governs this decan</span>, infusing Gemini's
                        intellectual realm with themes of relationship, harmony,
                        and social connection. This period calls for graceful
                        exchange of ideas and finding beauty in communication.
                      </p>
                      <div class="description_chips_wrapper">
                        <div class="description_chips">
                          Tarot: Nine of Swords
                        </div>
                        <div class="description_chips">
                          Element: Air + Venus
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="mystery_dashboard_dataleft_button"
                (click)="openComingSoon()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-zap h-4 w-4 mr-2"
                >
                  <path
                    d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                  ></path></svg
                >Continue Gemini - Decan 2 Module
              </button>
            </div>
          </div>
          <div class="mystery_dashboard_dataleft_block2">
            <div class="wrapper">
              <div class="dataleft_block_headingwrap">
                <div class="dataleft_block_headingicon">
                  <svg
                    _ngcontent-ng-c1581416418=""
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-star h-6 w-6"
                  >
                    <path
                      _ngcontent-ng-c1581416418=""
                      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                    ></path>
                  </svg>
                </div>
                <div class="dataleft_block_section">
                  <h3>Curriculum Map</h3>
                  <p>Navigate the Astrological Wheel</p>
                </div>
                <div class="dataleft_common_chip">4/12 Signs</div>
              </div>
              <div class="dataleft_block2_cardwrapper">
                <div class="wrapper wrapper_inner dataleft_block2_card">
                  <div class="dataleft_block2_card_heading">
                    <h4>Spring Quarter</h4>
                    <p>The Spark &amp; The Seed</p>
                  </div>
                  <div class="dataleft_block2_card_content">
                    <div class="dataleft_block2_card_content_innercard">
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-check-big h-4 w-4 mr-2"
                        >
                          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                          <path d="m9 11 3 3L22 4"></path></svg
                        >Aries
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Complete
                        </div>
                        <div
                          class="dataleft_block2_card_content_innercard_content_bottom"
                        >
                          <div
                            class="dataleft_block2_card_content_innercard_content_bottom_loader"
                          >
                            <mat-progress-bar
                              mode="determinate"
                              value="100"
                            ></mat-progress-bar>
                          </div>
                          <p
                            class="dataleft_block2_card_content_innercard_content_bottom_percent"
                          >
                            100% complete
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="dataleft_block2_card_content_innercard">
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-check-big h-4 w-4 mr-2"
                        >
                          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                          <path d="m9 11 3 3L22 4"></path></svg
                        >Taurus
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Complete
                        </div>
                        <div
                          class="dataleft_block2_card_content_innercard_content_bottom"
                        >
                          <div
                            class="dataleft_block2_card_content_innercard_content_bottom_loader"
                          >
                            <mat-progress-bar
                              mode="determinate"
                              value="100"
                            ></mat-progress-bar>
                          </div>
                          <p
                            class="dataleft_block2_card_content_innercard_content_bottom_percent"
                          >
                            100% complete
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_active"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-zap h-4 w-4 mr-2"
                        >
                          <path
                            d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                          ></path></svg
                        >Gemini
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Active
                        </div>
                        <div
                          class="dataleft_block2_card_content_innercard_content_bottom"
                        >
                          <div
                            class="dataleft_block2_card_content_innercard_content_bottom_loader"
                          >
                            <mat-progress-bar
                              mode="determinate"
                              value="60"
                            ></mat-progress-bar>
                          </div>
                          <p
                            class="dataleft_block2_card_content_innercard_content_bottom_percent"
                          >
                            60% complete
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wrapper wrapper_inner dataleft_block2_card">
                  <div class="dataleft_block2_card_heading">
                    <h4>Summer Quarter</h4>
                    <p>The Flow & The Flame</p>
                  </div>
                  <div class="dataleft_block2_card_content">
                    <div class="dataleft_block2_card_content_innercard">
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-clock h-4 w-4 mr-2"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline></svg
                        >Cancer
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Upcoming
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Leo
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Virgo
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wrapper wrapper_inner dataleft_block2_card">
                  <div class="dataleft_block2_card_heading">
                    <h4>Autumn Quarter</h4>
                    <p>The Balance & The Depths</p>
                  </div>
                  <div class="dataleft_block2_card_content">
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Libra
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Scorpio
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Sagittarius
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wrapper wrapper_inner dataleft_block2_card">
                  <div class="dataleft_block2_card_heading">
                    <h4>Winter Quarter</h4>
                    <p>The Summit & The Stars</p>
                  </div>
                  <div class="dataleft_block2_card_content">
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Capricorn
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Aquarius
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                    <div
                      class="dataleft_block2_card_content_innercard dataleft_block2_card_content_innercard_locked"
                    >
                      <button
                        (click)="openComingSoon()"
                        class="dataleft_block2_card_content_innercard_button"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-lock h-4 w-4 mr-2"
                        >
                          <rect
                            width="18"
                            height="11"
                            x="3"
                            y="11"
                            rx="2"
                            ry="2"
                          ></rect>
                          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg
                        >Pisces
                      </button>
                      <div
                        class="dataleft_block2_card_content_innercard_content"
                      >
                        <div
                          class="dataleft_block2_card_content_innercard_content_top"
                        >
                          Locked
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card_bottom_button_fullwidth">
                <button class="" (click)="openComingSoon()">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-book h-4 w-4 mr-2"
                  >
                    <path
                      d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                    ></path>
                  </svg>
                  Access Foundational Teachings
                </button>
              </div>
            </div>
          </div>
          <div class="mystery_dashboard_dataleft_block3">
            <div class="wrapper">
              <div class="dataleft_block_headingwrap">
                <div class="dataleft_block_headingicon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-book h-6 w-6 text-primary"
                  >
                    <path
                      d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
                    ></path>
                  </svg>
                </div>
                <div class="dataleft_block_section">
                  <h3>Your Journal</h3>
                  <p>Track your mystical insights</p>
                </div>
                <div class="dataleft_common_chip">12 entries</div>
              </div>

              <div class="dataleft_block3_journal_categorywrapper">
                <div class="dataleft_block3_journal">
                  <p class="dataleft_block3_journal_top">12</p>
                  <p class="dataleft_block3_journal_bottom">Total</p>
                </div>
                <div class="dataleft_block3_journal">
                  <p class="dataleft_block3_journal_top">3</p>
                  <p class="dataleft_block3_journal_bottom">This Month</p>
                </div>
                <div class="dataleft_block3_journal">
                  <p class="dataleft_block3_journal_top">4.2</p>
                  <p class="dataleft_block3_journal_bottom">Avg Rating</p>
                </div>
              </div>
              <button
                class="mystery_dashboard_dataleft_button"
                (click)="openComingSoon()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-plus h-4 w-4 mr-2"
                >
                  <path d="M5 12h14"></path>
                  <path d="M12 5v14"></path></svg
                >Create New Journal Entry
              </button>
              <div class="dataleft_block3_journal_cardwrapper">
                <h4 class="dataleft_block3_journal_cardsec_heading">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-clock h-4 w-4"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline></svg
                  >Recent Entries
                </h4>
                <div class="dataright_block1_notifications_wrapper">
                  <div class="dataright_common_data_card">
                    <div
                      class="dataright_common_data_card_innerwrapper data_card_flexstart"
                    >
                      <div class="dataright_common_data_card_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-star h-4 w-4 text-primary"
                        >
                          <path
                            d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                          ></path>
                        </svg>
                      </div>
                      <div class="dataright_common_data_card_contentsection">
                        <p class="dataright_notifications_text">
                          Gemini - Decan 1 Mental Plasticity Reflection
                        </p>
                        <div class="dataright_notifications_headingwrapper">
                          <div class="dataright_notifications_contentchip">
                            Feedback Received
                          </div>
                          <div class="stars_wrapper">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_normal"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path>
                            </svg>
                          </div>
                        </div>

                        <div class="dataright_notifications_actionwrapper">
                          <button
                            class="dataright_notifications_actionbutton"
                            (click)="openComingSoon()"
                          >
                            View
                          </button>
                          <div class="dataright_notifications_time">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-calendar h-3 w-3 mr-1"
                            >
                              <path d="M8 2v4"></path>
                              <path d="M16 2v4"></path>
                              <rect
                                width="18"
                                height="18"
                                x="3"
                                y="4"
                                rx="2"
                              ></rect>
                              <path d="M3 10h18"></path>
                            </svg>
                            June 4, 2025
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="dataright_common_data_card">
                    <div
                      class="dataright_common_data_card_innerwrapper data_card_flexstart"
                    >
                      <div class="dataright_common_data_card_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-check-big h-4 w-4 text-primary"
                        >
                          <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                          <path d="m9 11 3 3L22 4"></path>
                        </svg>
                      </div>
                      <div class="dataright_common_data_card_contentsection">
                        <p class="dataright_notifications_text">
                          Taurus - Decan 3 Stability Charm Crafting
                        </p>
                        <div class="dataright_notifications_headingwrapper">
                          <div class="dataright_notifications_contentchip">
                            Rated: 4/5
                          </div>
                          <div class="stars_wrapper">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_yellow"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path></svg
                            ><svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="star_normal"
                            >
                              <path
                                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                              ></path>
                            </svg>
                          </div>
                        </div>

                        <div class="dataright_notifications_actionwrapper">
                          <button
                            class="dataright_notifications_actionbutton"
                            (click)="openComingSoon()"
                          >
                            View
                          </button>
                          <div class="dataright_notifications_time">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-calendar h-3 w-3 mr-1"
                            >
                              <path d="M8 2v4"></path>
                              <path d="M16 2v4"></path>
                              <rect
                                width="18"
                                height="18"
                                x="3"
                                y="4"
                                rx="2"
                              ></rect>
                              <path d="M3 10h18"></path></svg
                            >May 28, 2025
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dataright_common_data_card">
                    <div
                      class="dataright_common_data_card_innerwrapper data_card_flexstart"
                    >
                      <div class="dataright_common_data_card_icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-clock h-4 w-4 text-primary"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                      </div>
                      <div class="dataright_common_data_card_contentsection">
                        <p class="dataright_notifications_text">
                          Taurus - Decan 2 Resource Sharing Contemplation
                        </p>
                        <div class="dataright_notifications_headingwrapper">
                          <div class="dataright_notifications_contentchip">
                            Submitted
                          </div>
                        </div>

                        <div class="dataright_notifications_actionwrapper">
                          <button
                            class="dataright_notifications_actionbutton"
                            (click)="openComingSoon()"
                          >
                            View
                          </button>
                          <div class="dataright_notifications_time">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-calendar h-3 w-3 mr-1"
                            >
                              <path d="M8 2v4"></path>
                              <path d="M16 2v4"></path>
                              <rect
                                width="18"
                                height="18"
                                x="3"
                                y="4"
                                rx="2"
                              ></rect>
                              <path d="M3 10h18"></path></svg
                            >May 21, 2025
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card_bottom_button_fullwidth">
                  <button class="" (click)="openComingSoon()">
                    View All Journal Entries
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mystery_dashboard_data_rightsec">
          <div class="mystery_dashboard_dataright_block1">
            <div class="wrapper">
              <h3 class="dataright_block_headingwrap">
                <div class="dataright_block_heading_left">
                  <div class="dataright_common_heading_icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-bell h-5 w-5 text-primary"
                    >
                      <path
                        d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
                      ></path>
                      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 class="dataright_common_mainheading">Notifications</h3>
                    <p class="dataright_common_subheading">
                      Stay updated with your progress
                    </p>
                  </div>
                </div>
                <div class="dataright_block_common_chipwrapper">
                  <div
                    class="dataright_block_common_chip all_notification_chip"
                  >
                    All
                  </div>
                  <div class="dataright_block_common_chip">2 new</div>
                </div>
              </h3>
              <div class="dataright_block1_notifications_wrapper">
                <div
                  class="dataright_common_data_card data_card_newnotificationbg"
                >
                  <div
                    class="dataright_common_data_card_innerwrapper data_card_flexstart"
                  >
                    <div class="dataright_common_data_card_icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-users h-4 w-4 text-primary"
                      >
                        <path
                          d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                        ></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <div class="dataright_notifications_contentchip">
                          Community
                        </div>
                        <div
                          class="phase_indicator phase_indicator_white"
                        ></div>
                      </div>
                      <p class="dataright_notifications_text">
                        New discussion in 'Nine of Swords Study Group'
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button class="dataright_notifications_actionbutton" (click)="openComingSoon()">
                          Join Discussion
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock h-3 w-3"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline></svg
                          >2 hours ago
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="dataright_common_data_card data_card_newnotificationbg"
                >
                  <div
                    class="dataright_common_data_card_innerwrapper data_card_flexstart"
                  >
                    <div class="dataright_common_data_card_icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-star h-4 w-4 text-primary"
                      >
                        <path
                          d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                        ></path>
                      </svg>
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <div class="dataright_notifications_contentchip">
                          Feedback
                        </div>
                        <div
                          class="phase_indicator phase_indicator_white"
                        ></div>
                      </div>
                      <p class="dataright_notifications_text">
                        Elias commented on your Mental Plasticity Reflection
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          View Feedback
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock h-3 w-3"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline></svg
                          >1 day ago
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card data_card_defaultbg">
                  <div
                    class="dataright_common_data_card_innerwrapper data_card_flexstart"
                  >
                    <div class="dataright_common_data_card_icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-archive h-4 w-4 text-primary"
                      >
                        <rect width="20" height="5" x="2" y="3" rx="1"></rect>
                        <path
                          d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"
                        ></path>
                        <path d="M10 12h4"></path>
                      </svg>
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <div class="dataright_notifications_contentchip">
                          New Content
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        New Scrying Exercise: 'The Venusian Mirror' available
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button class="dataright_notifications_actionbutton" (click)="openComingSoon()">
                          Begin Exercise
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock h-3 w-3"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline></svg
                          >2 days ago
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card data_card_defaultbg">
                  <div
                    class="dataright_common_data_card_innerwrapper data_card_flexstart"
                  >
                    <div class="dataright_common_data_card_icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-bell h-4 w-4 text-primary"
                      >
                        <path
                          d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
                        ></path>
                        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
                      </svg>
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <div class="dataright_notifications_contentchip">
                          System
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Gemini curriculum now available
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button class="dataright_notifications_actionbutton" (click)="openComingSoon()">
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-clock h-3 w-3"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline></svg
                          >2 weeks ago
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card_bottom_button_fullwidth">
                <button class="" (click)="openComingSoon()">
                  Mark All As Read
                </button>
              </div>
            </div>
          </div>
          <div
            class="mystery_dashboard_dataright_commonsec mystery_dashboard_dataright_block2"
          >
            <div class="wrapper">
              <h3 class="dataright_block_headingwrap">
                <div class="dataright_block_heading_left">
                  <div class="dataright_common_heading_icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-star h-5 w-5 text-primary"
                    >
                      <path
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <h3 class="dataright_common_mainheading">
                      Rituals & Practices
                    </h3>
                    <p class="dataright_common_subheading">
                      Sacred techniques for transformation
                    </p>
                  </div>
                </div>
              </h3>
              <div class="dataright_block1_notifications_wrapper">
                <div
                  class="dataright_common_data_card"
                  *ngFor="let slot of calendarData"
                >
                  <div class="calendar_card_innerwrapper">
                    <h4
                      class="calendar_card_heading"
                      [style]="{ background: slot.color_code }"
                    >
                      <span *ngIf="slot.holiday_event" class="holiday_icon"
                        >⭐</span
                      >
                      {{ slot.title }}
                    </h4>
                    <div class="calendar_card_date_subscribe_wrap">
                      <span class="calendar_card_date">{{
                        slot.start_datetime_Unix
                          | date
                            : "MMMM d, yyyy 'at' h:mm a"
                            : "+0530"
                            : "en-US"
                      }}</span>
                      <ng-container *ngIf="slot.subscription_availability">
                        <div
                          class="calendar_card_subscribe_button subscribe"
                          (click)="openSlotSubscription(slot)"
                          *ngIf="!slot.subscribed"
                        >
                          <p>
                            Subscribe
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-bell h-5 w-5 text-primary"
                            >
                              <path
                                d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"
                              ></path>
                              <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
                            </svg>
                          </p>
                        </div>
                        <div
                          class="calendar_card_subscribe_button unsubscribe"
                          (click)="openSlotSubscription(slot)"
                          *ngIf="slot.subscribed"
                        >
                          <p>
                            Subscribed
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-bell-ring h-5 w-5 text-primary"
                            >
                              <path
                                d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                              />
                              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                              <path d="M2 8c0-2.2.7-4.3 2-6" />
                              <path d="M22 8c0-2.2-.7-4.3-2-6" />
                            </svg>
                          </p>
                        </div>
                      </ng-container>
                    </div>
                    <p class="calendar_card_description">
                      {{ slot.description }}
                    </p>
                  </div>
                </div>

                
              </div>
              <ng-container *ngIf="slotLoader">
                  <mat-progress-bar mode="indeterminate" style="margin-top: 20px;"></mat-progress-bar>
                </ng-container>
              <div *ngIf="hasMore" class="card_bottom_button_fullwidth">
                <button class="" (click)="loadMore()" [disabled]="slotLoader">Show More</button>
              </div>
            </div>
          </div>
          <div
            class="mystery_dashboard_dataright_commonsec mystery_dashboard_dataright_block3"
          >
            <div class="wrapper">
              <h3 class="dataright_block_headingwrap">
                <div class="dataright_block_heading_left">
                  <div class="dataright_common_heading_icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-archive h-5 w-5 text-primary"
                    >
                      <rect width="20" height="5" x="2" y="3" rx="1"></rect>
                      <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"></path>
                      <path d="M10 12h4"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 class="dataright_common_mainheading">
                      Resource Library
                    </h3>
                    <p class="dataright_common_subheading">
                      Sacred knowledge repository
                    </p>
                  </div>
                </div>
              </h3>
              <div class="dataright_block1_notifications_wrapper">
                <div class="dataright_common_data_card">
                  <div class="dataright_common_data_card_innerwrapper">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/live-streaming_orange.png"
                        alt="Live Streaming Icon"
                      />
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <h4 class="dataright_card_heading">Live Streams</h4>
                        <div class="dataright_notifications_contentchip">
                          {{
                            contentCount?.live_stream !== null &&
                            contentCount?.live_stream !== undefined
                              ? contentCount.live_stream
                              : "N/A"
                          }}
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Broadcasted Wisdom & Real-Time Ceremonies
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-star h-3 w-3"
                          >
                            <path
                              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                            ></path></svg
                          >Lunar Gateway Transmission
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card">
                  <div class="dataright_common_data_card_innerwrapper">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/video_orange.png"
                        alt="Video Icon"
                      />
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <h4 class="dataright_card_heading">Video Library</h4>
                        <div class="dataright_notifications_contentchip">
                          {{
                            contentCount?.video_library !== null &&
                            contentCount?.video_library !== undefined
                              ? contentCount.video_library
                              : "N/A"
                          }}
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Recorded Teachings & Practice Footage
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-star h-3 w-3"
                          >
                            <path
                              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                            ></path></svg
                          >Astral Body Grounding Tutorial
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card">
                  <div class="dataright_common_data_card_innerwrapper">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/document_orange.png"
                        alt="Default Document Icon"
                      />
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <h4 class="dataright_card_heading">Documents</h4>
                        <div class="dataright_notifications_contentchip">
                          {{
                            contentCount?.document !== null &&
                            contentCount?.document !== undefined
                              ? contentCount.document
                              : "N/A"
                          }}
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Sacred Texts, Ritual Scripts & Diagrams
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-star h-3 w-3"
                          >
                            <path
                              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                            ></path></svg
                          >Inner Temple Blueprint
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card">
                  <div class="dataright_common_data_card_innerwrapper">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/youtube_orange.png"
                        alt="YouTube Icon"
                      />
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <h4 class="dataright_card_heading">YouTube Videos</h4>
                        <div class="dataright_notifications_contentchip">
                          {{
                            contentCount?.youtube_video !== null &&
                            contentCount?.youtube_video !== undefined
                              ? contentCount.youtube_video
                              : "N/A"
                          }}
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Public Sermons & Open Teachings
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-star h-3 w-3"
                          >
                            <path
                              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                            ></path></svg
                          >Saturn Return Guidance (YouTube)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dataright_common_data_card">
                  <div class="dataright_common_data_card_innerwrapper">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/announcement_orange.png"
                        alt="Announcement Icon"
                      />
                    </div>
                    <div class="dataright_common_data_card_contentsection">
                      <div class="dataright_notifications_headingwrapper">
                        <h4 class="dataright_card_heading">Announcements</h4>
                        <div class="dataright_notifications_contentchip">
                          {{
                            contentCount?.announcement !== null &&
                            contentCount?.announcement !== undefined
                              ? contentCount.announcement
                              : "N/A"
                          }}
                        </div>
                      </div>
                      <p class="dataright_notifications_text">
                        Updates, Alignments & Celestial Notices
                      </p>
                      <div class="dataright_notifications_actionwrapper">
                        <button
                          class="dataright_notifications_actionbutton"
                          (click)="openComingSoon()"
                        >
                          Explore
                        </button>
                        <div class="dataright_notifications_time">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-star h-3 w-3"
                          >
                            <path
                              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                            ></path></svg
                          >Summer Solstice Alignment Notice
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- << -------------- Old Dashboard ---------------- >> -->

  <!-- </div> -->
  <div class="mystery_container">
    <div class="mystery_container_inner">
      <app-mystery-school-header-navigation></app-mystery-school-header-navigation>
      <div class="mystery_content_wrapper">
        <div class="grey_gradientborder">
          <div class="mystery_content_block1">
            <div class="block1_content_top">
              <h3 class="continue_learn">CONTINUE LEARNING</h3>
              <h2 class="block1_heading">
                {{ trainingLessonData.next_training_name }}
              </h2>
              <p class="block1_subheading">
                {{ trainingLessonData.next_lesson_name }}
              </p>
            </div>
            <div class="block1_trainingsec">
              <h3 class="trainingsec_heading">Tarot Training Progress</h3>
              <div class="block1_training_progress_sec">
                <div class="block1_progressbar_sec">
                  <div class="common_progressbar_wrapper">
                    <div class="common_progressbar">
                      <div
                        class="common_progressbar_progress"
                        [style.width.%]="displayPercentage"
                      ></div>
                    </div>
                    <div class="common_progress_bottomsec">
                      <div class="common_progress_bottomsec_bullet">
                        <img
                          src="../../../assets/images/mystery-dashboard-images/mystery_training_progress_bullet.webp"
                          alt=""
                        />
                      </div>
                      <p class="progress_percent">
                        {{ displayPercentage }}% Complete
                      </p>
                    </div>
                  </div>
                </div>
                <div class="viewlesson_button">
                  <div
                    class="mysteryschool_commonbutton_wrapper buttonwithshadow"
                    (click)="goToLesson(trainingLessonData.next_training_id)"
                  >
                    <button class="mysteryschool_commonbutton">
                      Go to Lesson
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mysteryschool_page_banner">
          <div class="mysteryschool_page_banner_inner">
            <h2>The Wheel of the Year</h2>
            <p>
              Your journey through the signs. Content unlocks 7 days before each
              sign begins.
            </p>
          </div>
        </div>

        <div class="zodiaccard_wrapper">
          <app-zodiac-card
            *ngFor="let card of zodiacCards"
            [card]="card"
            class="zodiac_card"
          >
          </app-zodiac-card>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
